module.exports = __webpack_public_path__ + "img/image_big_logo.cde41f08.png";